// extracted by mini-css-extract-plugin
export default {"event":"EventItem_event__llej2","event--inactive":"EventItem_event--inactive__YbhpS"};